/* eslint-disable react/prop-types */
import React from 'react';
import Player from './Player';
import CallbackPlayer from './CallbackPlayer';
import './style.scss';
import useResizeObserver from 'use-resize-observer/polyfilled';

export default function Sequence({
  current = 0,
  frames,
  fallback = '',
  onload = () => {},
  onDrawn,
  active = false,
  name = '',
  visible = true
}) {
  const { ref, width = 1, height = 1 } = useResizeObserver();
  return (
    <div className="sequence" ref={ref} data-visible={visible}>
      {onDrawn && (
        <CallbackPlayer
          width={width}
          height={height}
          frames={frames}
          currentFrame={current}
          onload={onload}
          onDrawn={onDrawn}
          active={active}
        />
      )}
      {!onDrawn && (
        <Player width={width} height={height} frames={frames} currentFrame={current} onload={onload} active={active} name={name} />
      )}
    </div>
  );
}
